import { ForwardedRef, forwardRef, ReactElement } from 'react';
import { IconAlertTriangle, IconInfoCircle, IconX } from '@tabler/icons-react';
import { TagWrapper } from './TagWrapper';
import type { TagProps, IconTagVariant } from './types';

const tagIcons: Record<IconTagVariant, ReactElement> = {
  hint: <IconInfoCircle size={20} className='eye:text-blue-150' />,
  warning: <IconAlertTriangle size={20} className='eye:text-olive-100' />,
  error: <IconX size={20} className='eye:text-red-100' />,
};

export const Tag = forwardRef(function (
  { children, ...props }: TagProps,
  ref: ForwardedRef<HTMLDivElement>,
) {
  return (
    <TagWrapper ref={ref} {...props}>
      {tagIcons[props.variant as IconTagVariant]}
      {children}
    </TagWrapper>
  );
});

Tag.displayName = 'Tag';
